import { render, staticRenderFns } from "./passDetail.vue?vue&type=template&id=0594e1b2&"
import script from "./passDetail.vue?vue&type=script&lang=ts&"
export * from "./passDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports